import React from "react";
import Header3 from "../components/Header3";
import { Card } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";

const books = [
  {
    title: ["The Housemaid"],
    genre: "Freida McFadden",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["The Housemaid"],
    genre: "Freida McFadden",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["The Housemaid"],
    genre: "Freida McFadden",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];

const books1 = [
  {
    title: ["The Housemaid"],
    genre: "Freida McFadden",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "1:1 Meetup",
    image: require("../pages/image/book1.png"),
  },

  // Add more book data here as needed
];

const BooksGroupEventCreation = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bookcrathaed">
        <Header3 />
      </div>

      <div className="alincenterawidth">
        <div className="mb-5">
          <div
            className="mt-5 fw-bold textczoom11 aboutauther text-center text-md-start mlmrcrime"
            style={{ fontSize: "24px" }}
          >
            Crime & Thrillers - Available books for Group Meet-Ups
          </div>

          <div className="mx-sm-5  mb-4">
            <div
              className=" mx-5  textczoom11 fontupcon text-center text-sm-start fw-bold mt-5 fs-22"
              style={{ color: "#E36A29" }}
            >
              October 2024{" "}
            </div>

            <div className="d-flex justzomag11 flex-wrap jucfyy mx-5 gap-5 mt-3">
              {books.map((book, index) => (
                <Card
                  key={index}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    <Card.Img
                      className="imgsize"
                      variant="top"
                      src={book.image}
                      style={{ width: "152px", height: "215px" }}
                    />
                    <Card.Body className="p-0  ">
                      <Card.Title
                        className=" w-100 fs-22 fw-bold ftztitle "
                        style={{
                          color: "#383838",
                        }}
                      >
                        {book.title}
                      </Card.Title>

                      <Card.Title
                        className=" fs-22 fw-bold ftztitle "
                        style={{
                          color: "#6D6D6D",
                        }}
                      >
                        {book.genre}
                      </Card.Title>

                      <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-2 mt-sm-5">
                        {book.ageGroup}
                      </Card.Title>
                      <div className="mt-3">
                        <button
                          className="rounded-1 text-white border-0 mt-sm-4  editbtitn fw600 ftzgern fs-18 text-center text-dark"
                          style={{
                            backgroundColor: "#34C3C9",
                            width: "103px",
                            height: "34px",
                          }}
                          onClick={() => navigate("/booksdetails")}
                        >
                          Lead
                        </button>
                      </div>

                      {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>

            <div
              className=" mx-5 textczoom11 fontupcon text-center text-sm-start fw-bold mt-5 fs-22"
              style={{ color: "#E36A29" }}
            >
              {" "}
              November 2024{" "}
            </div>

            <div className="d-flex justzomag11 flex-wrap jucfyy  mx-5 gap-5 mt-3">
              {books1.map((book, index) => (
                <Card
                  key={index}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    <Card.Img
                      className="imgsize"
                      variant="top"
                      src={book.image}
                      style={{ width: "150px", height: "215px" }}
                    />
                    <Card.Body className="p-0  ">
                      <Card.Title
                        className=" w-100 fs-22 fw-bold ftztitle "
                        style={{
                          color: "#383838",
                        }}
                      >
                        {book.title}
                      </Card.Title>

                      <Card.Title
                        className=" fs-22 fw-bold ftztitle "
                        style={{
                          color: "#6D6D6D",
                        }}
                      >
                        {book.genre}
                      </Card.Title>

                      <Card.Title className=" fw-bold text-dark ftzgern fs-6 mt-sm-5 mt-2">
                        {book.ageGroup}
                      </Card.Title>
                      <div className="mt-3">
                        <button
                          className="rounded-1 border-0 text-white mt-sm-4 editbtitn fw600 ftzgern fs-18 text-center text-dark"
                          style={{
                            backgroundColor: "#34C3C9",
                            width: "103px",
                            height: "34px",
                          }}
                          onClick={() => navigate("/booksdetails")}
                        >
                          Lead
                        </button>
                      </div>

                      {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BooksGroupEventCreation;
